export default "__VITE_ASSET__49429686__"